import React, { useMemo, useState } from 'react'
import { StyledTileContainer } from './TileStyle'
import { getTileCarouselLogic } from './tile-carousels-logic-functions'
import TileV2Header from './components/TileV2Header'
import BrowseByCategory from '../BrowserByCategory'
import CardListV2 from './components/CardListV2'
import { useNavigate } from 'react-router-dom'

export default function TileV2({
  tileData,
  userData,
  tileId,
  policyId,
  tilePolicyId,
  isOnBackground,
}) {
  const [selectedCategory, setSelectedCategory] = useState(false)
  const navigate = useNavigate()

  const tileLogicAndData = useMemo(() => {
    return getTileCarouselLogic(tileData, {
      setSelectedCategory,
      navigate,
    })
  }, [tileData, navigate])

  return (
    <StyledTileContainer isOnBackground={isOnBackground}>
      {selectedCategory && (
        <BrowseByCategory
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          categoryList={tileData?.items}
          cardsType={tileData?.itemType}
          tileId={tileId}
          policyId={policyId}
          cardsCategory={tileData?.categoryType}
          tilePolicyId={tilePolicyId}
          //extras because of new format:
          categoryHeader={tileData?.title || tileData?.altText}
          fromMore
        />
      )}
      <CardListV2
        headingLogicAndData={{ ...tileLogicAndData.headingLogicAndData, isOnBackground }}
        tileLogicAndData={tileLogicAndData?.carouselLogicAndData}
      />
    </StyledTileContainer>
  )
}
